<div tabindex="0" class="me-appointment-booking-card" *ngIf="data">
    <div class="me-appointment-booking-card--title">
        {{data.title}}
    </div>

    <div class="me-appointment-booking-card--description" [innerHTML]="data.body | storyblokRichtext"></div>

    <div class="me-appointment-booking-card--btn">
        <div>
            <button class="btn btn--primary w-100" [routerLink]="['/me/appointment']">
                {{data.selectTherapistButton}}
            </button>
        </div>
        <div class="me-appointment-booking-card--btn--text">or</div>
        <div>
            <button class="btn btn--secondary w-100" [routerLink]="['/me/appointment/booking']">
                {{data.nextDateButton}}
            </button>
        </div>
    </div>
</div>